import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useError } from '../../contexts/ErrorContext';
import { api_post } from '@lf/api-client/lfApi';
import { donutChart } from '../../api/donutChart';
import { Calendar } from '@lf/ui-primitives';
const RecentActivities = ({ username }) => {
    const [history, setHistory] = useState({ daily_histories: [] });

    const navigate = useNavigate();

    const { setError } = useError();

    const getHistory = async () => {
        const response = await api_post(
            'history/',
            {
                username: username,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                days: 7,
            },
            setError,
        );
        if (response.status === 200 && response.data && response.data.daily_histories) {
            setHistory(response.data);
        }
        else {
            console.error('Failed to fetch history');
        }
    };

    const onVideo = (videoId, studyPlan, lesson, topic) => {
        navigate(`/video?vid=${videoId}&spid=${studyPlan.study_plan_id}&lid=${lesson.lesson_id}&topic=${topic}`)
    };

    const onSearchVideo = (videoId) => {
        navigate(`/video?vid=${videoId}`);
    };

    const getStarsEarned = (video) => {
        const threads = video?.data?.threads || [];
        return threads.reduce((sum, thread) => sum + Math.max(0, Number(thread.score) || 0), 0);
    };

    useEffect(() => {
        getHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div>
    {
        history.daily_histories.map((dailyHistory, historyIndex) => (
            <div key={historyIndex}>
                <div className="my-4">
                    <Calendar
                        dayOfWeek={dailyHistory.date.day_of_week}
                        day={dailyHistory.date.day}
                        monthYear={`${dailyHistory.date.month_str} ${dailyHistory.date.year}`} />
                </div>

                {
                    dailyHistory.study_plans.map((studyPlan, studyPlanIndex) => (
                        <div key={studyPlanIndex}>
                        {
                            studyPlan.lessons.map((lesson, lessonIndex) => (
                                <div key={lessonIndex}>
                                    <div className="font-bold">
                                        {studyPlan.subject}: {lesson.title}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 my-2">
                                        {
                                            lesson.videos.map((video, videoIndex) => (
                                                <div key={videoIndex} className="border rounded-2xl p-3 bg-white">
                                                    {/* Thumbnail */}
                                                    <div className="relative aspect-video rounded-xl overflow-hidden flex items-center justify-center bg-black w-full">
                                                        <img
                                                            src={video.thumbnail}
                                                            alt={video.title}
                                                            className="w-full object-fill cursor-pointer"
                                                            onClick={() => onVideo(video.video_id, studyPlan, lesson)}
                                                        />
                                                    </div>

                                                    {/* Title */}
                                                    <div className="mt-3 flex flex-col min-h-[132px]">
                                                        <h4 className="font-bold text-sm">
                                                            {video.title}
                                                        </h4>
                                                        <p className="text-sm">{video.channel_name}</p>

                                                        <div className="mt-auto pt-2 flex items-end justify-between gap-2">
                                                            <div className="flex items-end">
                                                                {donutChart({ percentage: video.data.progress })}
                                                                <div className="ml-1 text-sm leading-5">{video.data.progress}% completed</div>
                                                            </div>
                                                            <div className="text-sm font-semibold leading-5 text-amber-600">
                                                                ⭐ {getStarsEarned(video)}
                                                            </div>
                                                        </div>

                                                        {
                                                            video.data.summaries.length > 0 &&
                                                            <div className="mt-3 text-xs">
                                                                <div className="font-semibold">Lessons:</div>
                                                                <ul className="list-disc list-outside pl-5">
                                                                    {
                                                                        video.data.summaries.map((summary, summaryIndex) => (
                                                                            <li key={summaryIndex}>
                                                                                <span className="font-semibold">{summary.title}</span>: {summary.explanation}
                                                                            </li>
                                                                        ))
                                                                    }
                                                                </ul>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            ))
                        }
                        </div>
                    ))
                }

                {
                    dailyHistory.search_videos && dailyHistory.search_videos.length > 0 && (
                        <div>
                            <div className="font-bold mt-4">
                                🔍 Search Videos
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 my-2">
                                {
                                    dailyHistory.search_videos.map((video, videoIndex) => (
                                        <div key={videoIndex} className="border rounded-2xl p-3 bg-white">
                                            {/* Thumbnail */}
                                            <div className="relative aspect-video rounded-xl overflow-hidden flex items-center justify-center bg-black w-full">
                                                <img
                                                    src={video.thumbnail}
                                                    alt={video.title}
                                                    className="w-full object-fill cursor-pointer"
                                                    onClick={() => onSearchVideo(video.video_id)}
                                                />
                                            </div>

                                            {/* Title */}
                                            <div className="mt-3 flex flex-col min-h-[132px]">
                                                <h4 className="font-bold text-sm">
                                                    {video.title}
                                                </h4>
                                                <p className="text-sm">{video.channel_name}</p>

                                                <div className="mt-auto pt-2 flex items-end justify-between gap-2">
                                                    <div className="flex items-end">
                                                        {donutChart({ percentage: video.data.progress })}
                                                        <div className="ml-1 text-sm leading-5">{video.data.progress}% completed</div>
                                                    </div>
                                                    <div className="text-sm font-semibold leading-5 text-amber-600">
                                                        ⭐ {getStarsEarned(video)}
                                                    </div>
                                                </div>

                                                {
                                                    video.data.summaries.length > 0 &&
                                                    <div className="mt-3 text-xs">
                                                        <div className="font-semibold">Lessons:</div>
                                                        <ul className="list-disc list-outside pl-5">
                                                            {
                                                                video.data.summaries.map((summary, summaryIndex) => (
                                                                    <li key={summaryIndex}>
                                                                        <span className="font-semibold">{summary.title}</span>: {summary.explanation}
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        ))
    }
    </div>;
};

export default RecentActivities;
